import { APP_ENV } from '../../../environments';
import localPermissionGroups from './localPermissionGroups';
import uniq from 'lodash/uniq';

/**
 * Retrieves the list of local permissions a user may belong to.
 * 
 * @param { string } personId - The personId of the user to check permissions for.
 */
function getLocalPermissions( personId ) {
    let localUserPermissions = [];

    if ( !personId ) {
        return localUserPermissions;
    }

    // Loop through local permission groups and find groups for the environment the
    // webapp is being run in as well as groups the user is a part of (using personId).
    for ( let i = 0; i < localPermissionGroups.length; i++ ) {
        const group = localPermissionGroups[ i ];
        const groupEnv = group?.env;
        const groupPersonIds = group?.personIds || [];
        const groupPermissions = group?.permissions || [];

        const envMatch = ( APP_ENV === groupEnv );
        const personIdMatch = groupPersonIds.includes( personId );

        // If a group has been found that the user is a part of, collect the group's permissions
        // the user should receive (without adding duplicate permissions).
        if ( envMatch && personIdMatch ) {
            localUserPermissions.push( ...groupPermissions );
        }
    }

    // Remove duplicates from permissions array.
    localUserPermissions = uniq( localUserPermissions );

    return localUserPermissions;
}

export default getLocalPermissions;
